import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import { NineCellLoading } from 'react-loadingg';
import translateString from '../../utils/Locales';
import '../landingPage/style.css';
import ReactHtmlParser from 'react-html-parser';
import followUpSupportTicket from "../../services/followUpSupportTicket";
import getAdminSupportTickets from "../../services/getAdminSupportTickets";
import followUpAdminSupportTicket from "../../services/followUpAdminSupportTickets";
import getClient from "../../services/getClient";
import sendMail from "../../services/sendMainEmail";
import closeSupportTicket from "../../services/closeSupportTicket";
import Utils from "../../utils/utils";

let t = translateString;
const qs = require('querystring');

export default class AdminTicketDetails extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
      newTicket: false,
      isLoading: true,
      text: '',
      ticketId: '',
    };

  }
  
  async load() {

    this.setState({ isLoading: true });
    
    const parsed = qs.parse(window.location.hash);

    const ticketID = parsed['#/admin/ticketDetails?ticket'];
    this.setState({ ticketId: ticketID });

    await this.reloadTickets(ticketID);
  }

  async reloadTickets(id) {
    this.setState({ isLoading: true });
    
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.tickets = [];
    this.tickets = await getAdminSupportTickets(username, token);
    this.tickets = this.tickets.filter((ticket) => ticket.id === id || ticket.id_thread === id);

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
      await this.load();
  }

  async send() {

    if (this.state.text.trim() !== '') {
        this.setState({ isLoading: true });

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' }); 

        let res = await followUpAdminSupportTicket(username, token,  this.tickets[0].username, this.tickets[0].db_name, this.state.ticketId, this.tickets[0].subject, this.state.text.replace(/\n/g, '<br/>'));
        if(res !== null && res.result === 'ok') {
            
            let cliente = await getClient('', '', this.tickets[0].db_name);
            
            await sendMail(cliente.mail, cliente.ragioneSociale, 'New reply to your suppot\'s ticket', 'Hi ' + cliente.ragioneSociale + ",<br/>there's a new message for your ticket: " + this.tickets[0].subject + ".<br/>Please login to your support portal to see it and reply.<br/><br/>Thank you for reaching out Hdemia's Support.<br/>Best Regards, <br/><b>Hdemia's Team</b>");
            this.setState({ text: '', isLoading: false });
            await this.reloadTickets(this.state.ticketId);
        } else {
            this.setState({ isLoading: false });
            alert(t('errore_imprevisto'));
        }
    }
  }

  async completeTicket() {

    if (window.confirm('Vuoi davvero segnare questa richiesta di assistenza come completata?')) {
        
        const cookies = new Cookies(); 
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        
        let res = await closeSupportTicket(username, token, this.state.ticketId);
        if (res !== null && res.result === 'ok') {
            window.location.href = '/admin#/admin/tickets';
        } else {
            alert('Errore.');
        }
    }
  }

  render () {

    var current = 'user';

    if (this.state.isLoading || this.tickets.length === 0) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <div>
          <PageTitle title={this.tickets[0].subject} button={ this.tickets[0].solved === '0' ? 'Segna completato'.toUpperCase() : false } onClick={this.completeTicket.bind(this)} />

          <div style={{ position: 'absolute', bottom: 160, right: 0, left: 250, top: 180, paddingTop: 10, paddingBottom: 10, overflowX: 'hidden', overflowY: 'scroll' }}>
            { this.tickets.map((ticket) => {
              
              var curr = current;
              current = ticket.sentFrom;

              if (ticket.sentFrom === 'admin') {
                return(
                  <div key={ticket.id} style={{ ...ticketView, marginLeft: '25%', marginRight: '5%', marginTop: curr !== current ? 30 : 0, position: 'relative' }}>
                    <p>{ReactHtmlParser(ticket.message)}</p>
                    <p style={{ position: 'absolute', bottom: -5, right: 10, color: 'lightgrey' }}>{ticket.creation_date}</p>
                  </div>
                );
              } else {
                return (
                  <div key={ticket.id} style={{ ...ticketView, marginLeft: '5%', marginRight: '25%', marginTop: curr !== current ? 30 : 0, position: 'relative' }}>
                    <p>{ReactHtmlParser(ticket.message)}</p>
                    <p style={{ position: 'absolute', bottom: -5, right: 10, color: 'lightgrey' }}>{ticket.creation_date}</p>
                  </div>
                );
              }
            })}
          </div>
          { this.tickets[0].solved === '0' && <div>
                <textarea value={this.state.text} placeholder={t('inserisci_ticket')} style={{ position: 'absolute', bottom: 10, right: 100, left: 250, height: 100, border: 0, borderRadius: '10px', boxShadow: '0px 2px 10px lightgrey', paddingLeft: 30, paddingRight: 30, paddingTop: 15, paddingBottom: 15, whiteSpace: 'pre', resize: 'none' }} onChange={(e) => { this.setState({ text: e.target.value }); }}></textarea>
                <div className="btn btn-primary" onClick={this.send.bind(this)} style={{ position: 'absolute', right: 10, width: 80, bottom: 40 }}>{t('invia')}</div>
            </div> }
      </div>
    );
  }
}

const ticketView = {
    width: '70%', 
    backgroundColor: 'white', 
    boxShadow: '0px 2px 10px lightgrey', 
    borderRadius: '10px', 
    padding: 30,
    marginBottom: 5,
};  

